import { Guid } from "@/Common/Models/Guid";
import { PrescriptionRenewalsOrderType, SortDirection } from "@/Common/Models/UI/Enums";
import { PrescriptionRenewalSettings } from "@/PrescriptionRenewals/Models/Settings/PrescriptionRenewalSettings";

class PrescriptionRenewalRequest {
    public ResponsibleProviderContactId: Guid;
    public QueryOrderType: PrescriptionRenewalsOrderType;
    public QueryOrderDirection: SortDirection;
    public SearchText: string;
    public QueryCurrentPageNumber: number;
    public PrescriptionRenewalFilterSettings: PrescriptionRenewalSettings;

    constructor(fields?: Partial<PrescriptionRenewalRequest>) {
        Object.assign(this, fields);
    }
}

export { PrescriptionRenewalRequest };
